/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Card, CardBody, Col, Input, } from 'reactstrap';

import { setRUTFormat } from '../../../shared/utils';
import {
  getClients,
  getClientByRut,
  createClient,
  updateClientPassword,
  getClientPortal
} from '../../../redux/actions/clientsActions';
import { changeTitleAction } from '../../../redux/actions/topbarActions';

import QueryString from 'query-string';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import Table from '../../../shared/components/MaterialTable';
import RUTJS from 'rutjs';

import AddClientModal from './AddClientModal';
import SendNewPassModal from './SendNewPassModal';
import BasicNotification from '../../../shared/components/Notifications/BasicNotification';

// import ereaserIcon from '../../../shared/img/ereaser_icon.png';

const headers = [
  { id: 'NombreCliente', label: 'Nombre' },
  { id: 'RutCliente', label: 'Rut' },
  { id: 'actions', label: 'Acciones' },
];

class ClientsTable extends Component {

  state = {
    page: 0,
    limit: 10,
    search: '',
    found: false,
    clients: {},

    //campos cliente
    rut: '',
    email: '',
    nameCompany: '',
    name: '',
    lastname: '',
    lastnameM: '',

    //modal add client
    isOpenModalAC: false,
    hideNewClient: true,
    unknownError: false,
    clientExist: false,
    clientFound: true,
    clientInPortal: false,
    clientNotFound: false,

    //modal send new pasword
    isOpenSNP: false

  };

  componentDidMount = async () => {
    const { fetchClients, location } = this.props;
    this.props.changeTitleAction('Clientes');

    let { page = 1, limit = 10 } = QueryString.parse(location.search);

    const query = {};

    if (page && !Number.isNaN(page)) {
      page = parseInt(page, 10) - 1;
      Object.assign(query, { page: page + 1 });
    }
    if (limit && !Number.isNaN(limit)) {
      limit = parseInt(limit, 10);
      Object.assign(query, { limit });
    }
    this.setState({ page, limit });

    await fetchClients({ ...query });
  }

  onChangePage = (page) => {
    const { fetchClients, history, location } = this.props;
    this.setState({ page });
    const query = QueryString.parse(location.search);
    history.push(`/clientes?${QueryString.stringify({ ...query, page: page + 1 })}`);
    fetchClients({ ...query, page: page + 1 });
  }

  onChangeSearch = (e) => {
    this.setState({ search: e.target.value });
  }

  formatRut = (search) => {
    search = this.state.search.toString().split('.').join("");
    let searchFix = ''
    search.includes('-') ?
      searchFix = search : searchFix = search.slice(0, search.length - 1) + "-" + search.substring(search.length - 1);
    return searchFix
  }

  // busqueda en tabla
  onSubmitSearchPortal = async (e) => {
    e.preventDefault();
    const { getClientPortal } = this.props;
    let searchFix = this.formatRut(this.state.search);
    //busca en portal cliente
    await getClientPortal(searchFix);
    this.existsInPortal(searchFix);
  }

  existsInPortal = async (search) => {
    const { getClientByRut, clientPortal } = this.props;
    //si existe en portal cliente se traen los datos de trinidad
    if (clientPortal) {
      // se obtienen los datos de trinidad
      await getClientByRut(search);
      this.getClientDetails(search);
    } else {
      BasicNotification.error('Cliente no está registrado en el portal.');
    }
  }

  getClientDetails = (searchFix) => {
    const { entryByRut } = this.props;
    //comprueba si el cliente existe en trinidad
    entryByRut.CodigoCliente ? this.props.history.push(`/clientes/${searchFix}`) : this.setState({ clientFound: false })
  }
  // fin de busqueda en tabla


  // busqueda en modal
  onSubmitSearch = async (e) => {
    e.preventDefault();
    const { getClientPortal, getClientByRut } = this.props;
    let search = this.state.rut.toString().split('.').join("");
    await getClientByRut(search);
    await getClientPortal(search);
    this.existsInPortalModal(search);
  }

  existsInPortalModal = async (search) => {
    const { clientPortal, getClientByRut, entryByRut } = this.props;
    //si existe en portal cliente se traen los datos de trinidad
    if (entryByRut.CodigoCliente !== undefined) {
      if (clientPortal) {
        this.setState({ clientInPortal: true, clientNotFound: false });
      } else {
        await getClientByRut(search);
        this.setDataModal();
        this.setState({ clientFound: false, clientInPortal: false, clientNotFound: false });
      }
    } else {
      this.setState({ clientNotFound: true, clientInPortal: false });
    }
  }

  setDataModal = async () => {
    const { entryByRut } = this.props;
    this.setState({
      rut: entryByRut.RutCliente ? entryByRut.RutCliente : '',
      email: entryByRut.EmailsCliente !== undefined && entryByRut.EmailsCliente.length > 0 ? entryByRut.EmailsCliente[0].Email : '',
      nameCompany: entryByRut.NombreCliente ? entryByRut.NombreCliente : '',
      name: entryByRut.Nombre ? entryByRut.Nombre : '',
      lastname: entryByRut.ApellidoPaterno ? entryByRut.ApellidoPaterno : '',
      lastnameM: entryByRut.ApellidoMaterno ? entryByRut.ApellidoMaterno : '',
    })
  }
  // fin de busqueda en modal

  onChangeLimit = (limit) => {
    const { fetchClients, history, location } = this.props;
    this.setState({ limit });
    const query = QueryString.parse(location.search);
    history.push(`/clientes?${QueryString.stringify({ ...query, limit })}`);
    fetchClients({ ...query, limit });
  }

  onSubmitAddClient = () => {
    const { createClient, clientError } = this.props;
    let name = '';

    name = this.state.name + " " + this.state.lastname + " " + this.state.lastnameM;

    if (this.state.nameCompany.length > 2) {
      name = this.state.nameCompany;
    }

    createClient({
      name: name.toUpperCase(),
      dni: this.state.rut.toString().split('.').join(""),
      email: this.state.email
    });

    if (!clientError) {
      this.setState({
        rut: '',
        email: '',
        name: '',
        lastname: '',
        lastnameM: '',
        isOpenModalAC: false,
        clientExist: false
      })
    } else {
      clientError === 400 ? this.setState({ hideNewClient: false }) : this.setState({ unknownError: true });
    }

    window.location.assign(window.location.href);
  }

  toggleModalAC = () => {
    this.setState({
      clientFound: true,
      clientInPortal: false,
      clientExist: false,
      isOpenModalAC: false,
    });
  };

  toggleModalSNP = () => {
    this.setState({ isOpenSNP: false });
  }

  toggleClientExists = () => {
    this.setState({
      clientExist: true,
    });
  }

  toggleCancelClientExists = () => {
    this.setState({
      clientExist: false,
      clientInPortal: false
    });
  }

  onClickModalAddClient = () => {
    this.setState({
      clientInPortal: false,
      clientNotFound: false,
      clientFound: true,
      isOpenModalAC: true,
      hideNewClient: true,
      rut: '',
      email: '',
      name: '',
      lastname: '',
      lastnameM: '',
    });
  }

  onChangeInput = key => (e) => {
    if (key === 'rut') {
      this.setState({ [key]: setRUTFormat(e.target.value) });
    } else {
      this.setState({ [key]: e.target.value });
    }
  }

  isRUTValid = (rut) => {
    if (!rut) return true;
    return (new RUTJS(rut)).isValid;
  }

  viewDetail(dni) {
    // const { history } = this.props;
    this.props.history.push(`/clientes/${dni}`);
  }

  onSubmitSend = () => {
    const { entryByRut, updateClientPassword } = this.props;
    updateClientPassword({
      dni: entryByRut.RutCliente,
      email: entryByRut.EmailsCliente[0].Email,
      name: entryByRut.Nombre
    });
    this.setState({
      isOpenSNP: false,
      email: '',
      name: ''
    });
  }

  onClickModalSNP = async (dni) => {
    const { getClientByRut } = this.props;
    await getClientByRut(dni);
    this.getClientEmail()
  }

  getClientEmail = () => {
    const { entryByRut } = this.props;
    entryByRut.EmailsCliente && this.setState({ found: true });
    if (this.state.found && entryByRut.EmailsCliente !== undefined && entryByRut.EmailsCliente.length > 0) {
      this.setState({
        isOpenSNP: true,
        email: entryByRut.EmailsCliente[0].Email,
        name: entryByRut.NombreCliente
      });
    } else {
      BasicNotification.error('Ocurrió un error al intentar enviar contraseña.');
    }
    this.setState({ found: false });
  }

  componentWillUnmount() {
    this.props.changeTitleAction('');
  }

  render() {
    const { collection, count, loading } = this.props;
    const { page, limit } = this.state;

    const data = collection.map(item => ({
      id: item.CodigoCliente,
      cells: (
        <Fragment key={item.CodigoCliente}>
          <TableCell className="material-table__cell" style={{ borderBottom: '0px' }} onClick={() => this.viewDetail(item.dni)} align="left">
            {item.name}
          </TableCell>
          <TableCell className="material-table__cell" style={{ borderBottom: '0px' }} onClick={() => this.viewDetail(item.dni)} align="left">
            {setRUTFormat(item.dni)}
          </TableCell>
          <TableCell className="material-table__cell" align="left">
            {/* <button className="table-button" type="button" onClick={() => this.viewDetail(item.dni)}>
              <span
                className="lnr lnr-lnr lnr-eye"
                style={{
                  fontSize: '20px', fontWeight: 'bold', cursor: 'pointer', color: '#000',
                }}
              />
            </button> */}
            <button className="table-button" type="button" onClick={() =>
              // this.sendNewPassword(item.dni, item.name);
              this.onClickModalSNP(item.dni)
            }>
              <span
                className="lnr lnr-lnr lnr-envelope"
                style={{
                  fontSize: '20px', fontWeight: 'bold', cursor: 'pointer', color: '#000',
                }}
              />
            </button>
          </TableCell>
        </Fragment>
      ),
    }));


    return (
      <div className="clients">
        <AddClientModal
          isOpen={this.state.isOpenModalAC}
          toggle={this.toggleModalAC}
          onSubmitAddClient={this.onSubmitAddClient}
          onChangeInput={this.onChangeInput}
          value={this.state}
          title="Agregar Cliente"
          isRUTValid={this.isRUTValid}
          clientFound={this.state.clientFound}
          hideNewClient={this.state.hideNewClient}
          unknownError={this.state.unknownError}
          onSubmitSearch={this.onSubmitSearch}
          clientExist={this.state.clientExist}
          toggleClientExists={this.toggleClientExists}
          toggleCancelClientExists={this.toggleCancelClientExists}
          clientInPortal={this.state.clientInPortal}
          clientNotFound={this.state.clientNotFound}
        />
        <SendNewPassModal
          isOpen={this.state.isOpenSNP}
          toggle={this.toggleModalSNP}
          value={this.state}
          onSubmitSend={this.onSubmitSend}
          toggleClientExists={this.toggleClientExists}
        />
        <Card style={{ paddingBottom: '10px' }}>
          <CardBody className="card_body_flex" style={{ padding: '5px 10px' }}>
            <Col md="8" style={{ display: 'flex', flexWrap: 'wrap' }}>
              <Col xs="auto" sm="auto" md="auto" style={{ padding: '0px' }}>
                <form
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                  }}
                  // onSubmit={this.onSubmitSearch}
                  onSubmit={this.onSubmitSearchPortal}
                >
                  <span className="lnr lnr-magnifier form-control-feedback" />
                  <Input className="find_of_bar" id="byFindIt" onChange={this.onChangeSearch} value={this.state.search} placeholder="Nombre Cliente, Rut Cliente" style={{ marginTop: '3.5%', marginLeft: '8px', paddingLeft: '25px' }} />
                  {/* {
                    (this.state.search) && (
                      <button type="button" style={{ margin: '10px 0px 0px 10px' }} className="btn2 asignar2">
                        <img src={ereaserIcon} alt="" style={{ width: '15px' }} />
                      </button>
                    )
                  } */}
                </form>
              </Col>
            </Col>
            <Col md="4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Col xs="auto" sm="auto" md="auto" style={{ marginTop: '2.5%' }}>
                <button
                  type="button"
                  style={{ fontSize: '13px' }}
                  className="asignar2 new_contact_button"
                  onClick={() => this.onClickModalAddClient()}>+ Cliente Portal</button>
              </Col>
            </Col>
          </CardBody>
        </Card>
        <Table
          cargando={loading}
          data={data}
          headers={headers}
          page={page}
          rowsPerPage={limit}
          selected={[]}
          total={count}
          onChangePage={this.onChangePage}
          onChangeRowsPerPage={this.onChangeLimit}
        />
      </div>
    );
  }
}

ClientsTable.propTypes = {
  collection: PropTypes.array.isRequired,
  // count: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  fetchClients: PropTypes.func.isRequired,
};

const mapState = ({ clients }) => ({
  collection: clients.collection,
  loading: clients.loading,
  count: clients.count,
  entryByRut: clients.entry,
  gettingByRut: clients.getting,
  clientError: clients.error,
  clientExists: clients.exists,
  clientPortal: clients.client
});

const mapDispatch = {
  fetchClients: getClients,
  getClientByRut,
  changeTitleAction,
  createClient,
  updateClientPassword,
  getClientPortal
};

export default connect(mapState, mapDispatch)(ClientsTable);
